import { render, staticRenderFns } from "./ProjectsListItem.vue?vue&type=template&id=a892054e&"
import script from "./ProjectsListItem.vue?vue&type=script&lang=js&"
export * from "./ProjectsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports